<span class="label">
  {{ label() }}
  @if (required()) {
    *
  }
</span>
<ng-content></ng-content>
